import { ReactNode } from 'react';
import { Sidebar } from '@/components/Sidebar';
import { BottomNav } from '@/components/BottomNav';
import { useSidebarStore } from '@/stores/sidebar-store';
import { cn } from '@/utils/cn';
import './layout.css';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { isCollapsed } = useSidebarStore();

  return (
    <div className="layout">
      <Sidebar />
      <div className={cn('layout__main', isCollapsed && 'layout__main--collapsed')}>
        <main className="layout__content">{children}</main>
      </div>
      <BottomNav />
    </div>
  );
}

